<template>
  <div v-if="value" class="modal-container" :class="{ small }" @click.self="close">
    <div class="modal-content">
      <button @click.prevent="close" class="modal-close-button">
        <span class="material-icons">close</span>
      </button>
      <div class="scroll-container">
        <div v-if="title" class="modal-header">
          <h2 class="modal-title">
            {{ title }}
          </h2>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    small: { type: Boolean, default: false },
    title: { type: String, required: false },
    value: { type: Boolean, default: false },
  },
  watch: {
    value() {
      this.value ? document.body.classList.add('no-scroll') : document.body.classList.remove('no-scroll')
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss">
.modal-container {
  --modal-max-width: 1200px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: var(--modal-backdrop-color);
  z-index: 99999;

  &.small {
    --modal-max-width: 900px;
  }
}

.scroll-container {
  overflow-y: auto;
  width: 100%;
  height: 100%;
  flex-grow: 1;
}

.modal-content {
  display: flex;
  position: relative;
  flex-direction: column;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: calc(100% - 1rem);
  max-width: var(--modal-max-width);
  max-height: 85%;
  overflow: hidden;
  background-color: #f1f1f1;
  border-radius: var(--border-radius-m);
  box-shadow: var(--modal-shadow);

  .content-wrap {
    max-width: var(--modal-max-width);
    margin: 0 auto;
    border-radius: 0;
  }

  .body-content {
    padding: 0;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem;
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
  }

  .modal-title {
    margin: 0;
    font-size: 2rem;
  }

  .modal-close-button {
    top: 0;
    right: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    background: none;
    border: none;
    cursor: pointer;
  }
}
</style>
